

export interface ProcessStep {
  title: string;
  text: string;
}

export const steps: ProcessStep[] = [
  {
    title: "landing.stepsProcessSection.step1.title",
    text: "landing.stepsProcessSection.step1.text"
  },
  {
    title: "landing.stepsProcessSection.step2.title",
    text: "landing.stepsProcessSection.step2.text"
  },
  {
    title: "landing.stepsProcessSection.step3.title",
    text: "landing.stepsProcessSection.step3.text"
  }
];
